module.exports = __webpack_public_path__ + "img/earth-works-footer.7e8912e3.png";